import { apiClient } from '@/lib/api-client';
import type { AuditLog, PaginatedResponse } from '@/types/api';

export interface AuditLogFilters {
  resourceType?: string;
  userId?: string;
  from?: string;
  to?: string;
  page?: number;
  perPage?: number;
}

export async function getAuditLogs(filters: AuditLogFilters = {}): Promise<PaginatedResponse<AuditLog>> {
  const params = new URLSearchParams();
  if (filters.resourceType) params.set('resourceType', filters.resourceType);
  if (filters.userId) params.set('userId', filters.userId);
  if (filters.from) params.set('from', filters.from);
  if (filters.to) params.set('to', filters.to);
  if (filters.page) params.set('page', String(filters.page));
  if (filters.perPage) params.set('perPage', String(filters.perPage));

  const response = await apiClient.get<PaginatedResponse<AuditLog>>(`/audit-logs?${params.toString()}`);
  return response.data;
}
